import React from "react";
import styles from "./tab.module.scss";

type TabProps = {
	label: string;
	onClick: () => void;
	active: boolean;
};

const Tab: React.FC<TabProps> = ({ label, onClick, active }) => {
	return (
		<button className={`${styles.tab} ${active? styles.active: ""}`} onClick={onClick}>
			{label}
		</button>
	);
};

type TabComponentProps = {
	activeTab: string;
	onTabChange: (tab: string) => void;
};

const TabComponent: React.FC<TabComponentProps> = ({ activeTab, onTabChange }) => {
	const tabs = ["Consumer", "Associate Installer"];
    //, "Distributor that installs", "Manufacturer that installs"
	return (
		<div className={styles.tabContainer}>
			{tabs.map(tab => (
				<Tab key={tab} label={tab} onClick={() => onTabChange(tab)} active={activeTab === tab} />
			))}
		</div>
	);
};

export default TabComponent;
